import apiService from './api';

export interface QaPlatform {
  platform_name: string;
  platform_url: string;
  da_score: number;
}

export interface QaModuleData {
  project_context: any;
  platforms: QaPlatform[];
  is_new_website: boolean;
  domain_age_months: number;
}

export interface QaAnswer {
  id: string;
  generation_id: string;
  platform_name: string;
  platform_url?: string;
  question?: string;
  question_url?: string;
  answer?: string;
  word_count?: number;
  keyword?: string;
  website_url?: string;
  published_platforms?: string[];
  status: string;
  is_user_modified: boolean;
  created_at: string;
  updated_at?: string;
}

export const getModuleData = async (): Promise<QaModuleData> => {
  return await apiService.request<QaModuleData>(
    '/qa-submission/module-data',
    { method: 'GET' }
  );
};

export const generateContent = async (platformNames: string[], targetKeyword?: string): Promise<{ generation_id: string; status: string }> => {
  return await apiService.request<{ generation_id: string; status: string }>(
    '/qa-submission/generate-content',
    {
      method: 'POST',
      body: JSON.stringify({ platform_names: platformNames, target_keyword: targetKeyword })
    }
  );
};

export const getGeneratedAnswers = async (generationId: string): Promise<QaAnswer[]> => {
  return await apiService.request<QaAnswer[]>(
    `/qa-submission/generated/${generationId}`,
    { method: 'GET' }
  );
};

export const getAllAnswers = async (): Promise<QaAnswer[]> => {
  return await apiService.request<QaAnswer[]>(
    '/qa-submission/answers',
    { method: 'GET' }
  );
};

export const updateAnswer = async (answerId: string, data: any): Promise<QaAnswer> => {
  return await apiService.request<QaAnswer>(
    `/qa-submission/answers/${answerId}`,
    {
      method: 'PUT',
      body: JSON.stringify(data)
    }
  );
};
